import React, { useRef, useState } from "react";
import { TimelineHeader } from "./TimelineHeader";
import { TimelineActions } from "./TimelineActions";
import { TimelineCanvas } from "./TimelineCanvas";
import { TimelineModal } from "./TimelineModal";
import { useTimelineExport } from "./hooks/useTimelineExport";
import type { TimelineData } from "@/lib/chat/parseTimelineBlock";

interface TimelineProps {
  data: TimelineData;
}

export const Timeline: React.FC<TimelineProps> = ({ data }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const { exportPNG } = useTimelineExport(containerRef, data.title);

  return (
    <>
      <div
        ref={containerRef}
        className="relative w-full overflow-hidden rounded-lg border border-border bg-card shadow-sm"
      >
        <TimelineHeader title={data.title} />
        <TimelineCanvas data={data} />
        <TimelineActions
          onDownload={exportPNG}
          onExpand={() => setExpanded(true)}
        />
      </div>

      <TimelineModal
        open={expanded}
        onClose={() => setExpanded(false)}
        data={data}
      />
    </>
  );
};
